/**
 * Custom Devices Icon
 * Server rack design with two horizontal units
 */

interface DevicesIconProps {
  size?: number;
  className?: string;
}

export function DevicesIcon({ size = 24, className }: DevicesIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M26.6667 2.66663H5.33332C3.86056 2.66663 2.66666 3.86053 2.66666 5.33329V10.6666C2.66666 12.1394 3.86056 13.3333 5.33332 13.3333H26.6667C28.1394 13.3333 29.3333 12.1394 29.3333 10.6666V5.33329C29.3333 3.86053 28.1394 2.66663 26.6667 2.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M26.6667 18.6666H5.33332C3.86056 18.6666 2.66666 19.8605 2.66666 21.3333V26.6666C2.66666 28.1394 3.86056 29.3333 5.33332 29.3333H26.6667C28.1394 29.3333 29.3333 28.1394 29.3333 26.6666V21.3333C29.3333 19.8605 28.1394 18.6666 26.6667 18.6666Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 8H8.01333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 24H8.01333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default DevicesIcon;
